import { wsDriver } from '@leagueplatform/masonry';
import {
  MASONRY_NAMESPACES,
  MASONRY_WIDGET_TYPES,
} from 'common/constants/masonry';
import { ActivityStack } from 'components/masonry-renderers/activity_stack.component';

export const initHealthJourneyWSRegistry = () => {
  wsDriver.nodeRendererRegistry.overrideRenderer(
    MASONRY_WIDGET_TYPES.ACTIVITY_STACK,
    MASONRY_NAMESPACES.HEALTH_JOURNEY,
    ActivityStack,
  );
};
